import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import BottomNav from '../components/layout/bottomNav';
import './notifications.css';

import MobileHeader from '../components/layout/mobileHeader';

const Notifications = () => {
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState([]);

  const loadNotifications = async () => {
    const { data, error } = await supabase
      .from('mobile_notifications')
      .select('*')
      .order('created_at', { ascending: false });

    if (error) {
      console.error('Notifications load failed:', error.message);
      return;
    }

    setNotifications(data || []);
  };

  useEffect(() => {
    loadNotifications();

    const channel = supabase
      .channel('mobile_notifications_changes')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'mobile_notifications',
        },
        () => loadNotifications()
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, []);

  const unreadCount = notifications.filter((item) => !item.is_read).length;

  const todayNotifications = useMemo(
    () => notifications.filter((item) => item.section === 'Today'),
    [notifications]
  );

  const weekNotifications = useMemo(
    () => notifications.filter((item) => item.section === 'This week'),
    [notifications]
  );

  const markAsRead = async (id) => {
    await supabase
      .from('mobile_notifications')
      .update({ is_read: true })
      .eq('id', id);

    loadNotifications();
  };

  return (
    <main className="notificationsPage">
        <MobileHeader />

      <div className="notificationsTitleRow">
        <button className="backBtn" onClick={() => navigate(-1)}>
          ‹
        </button>

        <h1>Notifications</h1>

        <span>{unreadCount}</span>
      </div>

      <NotificationSection
        title="Today"
        items={todayNotifications}
        onRead={markAsRead}
      />

      <NotificationSection
        title="This week"
        items={weekNotifications}
        onRead={markAsRead}
      />

      <BottomNav activePage="notifications" />
    </main>
  );
};

const NotificationSection = ({ title, items, onRead }) => {
  if (!items.length) return null;

  return (
    <section className="notificationSection">
      <h2>{title}</h2>

      <div className="notificationList">
        {items.map((item) => (
          <button
            key={item.id}
            className="notificationItem"
            onClick={() => onRead(item.id)}
          >
            <div className="notificationIcon">
              <span>♢</span>
            </div>

            <div className="notificationContent">
              <p>{item.type}</p>
              <h3>{item.title}</h3>
              <h4>{item.message}</h4>
            </div>

            {!item.is_read && <span className="unreadDot"></span>}
          </button>
        ))}
      </div>
    </section>
  );
};

export default Notifications;